import React from 'react';
import { FadeIn, Section } from './Section';
const premiumAddons = [{
  title: '4 Plantillas y Workbooks Descargables',
  desc: 'Una plantilla práctica para cada parte del ebook. Ejercicios, reflexiones guiadas y hojas de trabajo que te llevan de la lectura a la acción concreta en minutos. Imprimibles o editables desde tu celular.'
}, {
  title: 'Sesión Grupal en Vivo Mensual',
  desc: 'Una vez al mes, una sesión donde trabajamos juntas en vivo. Traés tus dudas, tu oferta, tu precio o tu bloqueo del momento y lo resolvemos en grupo. Porque a veces lo que necesitás no está en un PDF — está en escucharte y que alguien te diga "eso vale, cobralo."'
}, {
  title: '30 Días de Soporte por Voz vía Instagram',
  desc: 'Acceso directo por mensajes de voz durante 30 días. Dudas puntuales, frenos del camino, decisiones que no sabés cómo tomar — respondidas en tiempo real por alguien que ya recorrió ese camino.'
}, {
  title: 'Plan de Acción Personalizado según tu Situación Real',
  desc: 'No un plan genérico — uno diseñado para vos, tu habilidad, tu punto de partida y tus metas. Sabés exactamente qué hacer, en qué orden y cuándo. Sin improvisar, sin perderte.'
}];
export function PremiumDetails() {
  return <Section bg="cream" data-id="element-197">
      <FadeIn className="text-center mb-10 md:mb-20" data-id="element-198">
        <h2 className="text-xs md:text-sm font-bold tracking-[0.2em] uppercase text-plum/60 mb-4" data-id="element-199">
          ¿Qué agrega Mujer Expansiva Premium?
        </h2>
        <p className="font-serif text-2xl md:text-5xl text-plum mb-6 md:mb-8 px-4" data-id="element-200">
          Para la mujer que no solo quiere el mapa... sino llegar
        </p>

        <div className="max-w-3xl mx-auto bg-cream-dark/50 p-5 md:p-8 text-left rounded-sm border border-plum/5" data-id="element-201">
          <p className="mb-3 md:mb-4 text-sm md:text-base text-plum/80" data-id="element-202">
            <strong className="text-plum uppercase tracking-wider text-[10px] md:text-sm" data-id="element-203">
              Sin Premium:
            </strong>{' '}
            Aplicás el método completo, a tu ritmo, con todas las herramientas
            del ebook y los 5 bonos.
          </p>
          <p className="text-sm md:text-base text-plum/80" data-id="element-204">
            <strong className="text-plum uppercase tracking-wider text-[10px] md:text-sm" data-id="element-205">
              Con Premium:
            </strong>{' '}
            Además de todo el contenido, tenés acompañamiento real para que no
            te quedes sola en el proceso.
          </p>
        </div>
      </FadeIn>

      <div className="max-w-4xl mx-auto" data-id="element-206">
        <h3 className="text-center text-xs md:text-sm font-bold tracking-[0.2em] uppercase text-gold mb-8 md:mb-12" data-id="element-207">
          Premium Incluye:
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12" data-id="element-208">
          {premiumAddons.map((addon, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-209">
              <h4 className="font-serif text-xl md:text-2xl text-plum mb-2 md:mb-3" data-id="element-210">
                {addon.title}
              </h4>
              <p className="text-sm md:text-base text-plum/70 leading-relaxed" data-id="element-211">
                {addon.desc}
              </p>
            </FadeIn>)}
        </div>
      </div>
    </Section>;
}